import { css } from '@emotion/react'
import React from 'react'

function TabPanel({ children, index, style }) {
    return <div css={css`${style}`} className='tab-panel' index={index}>{children}</div>
}

export default TabPanel
